import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { GetInfoBarDataResponse } from "./getInfoBarData.types";
import { requestGetInfoBarData } from "./requestGetInfoBarData.request";

const useGetInfoBarData = (
  options?: QueryOptions<GetInfoBarDataResponse, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["info-bar-data"],
    queryFn: requestGetInfoBarData,
    ...options
  });

  return { infoBarData: data?.information, ...rest };
};

export default useGetInfoBarData;
